/* Dakol v1: motion.js (właściciel: design-strona-glowna). Ładowany przez base.js (data-component="motion" data-load="now").
   1. [data-reveal] i [data-reveal-group]: klasa .is-in po wejściu w widok (IntersectionObserver), elementy już widoczne od razu;
      dzieci grup i [data-reveal-item] dostają --reveal-i (kaskada), data-reveal-delay przepisany na --reveal-delay.
   2. Nagłówek: html.is-scrolled po przewinięciu, html.is-scrolling-down przy przewijaniu w dół (nagłówek chowa się, wraca przy ruchu w górę).
   3. Pasek ogłoszeń: inert na komunikatach schowanych w zawiniętym wierszu.
   Reduced motion: tylko .is-in bez obserwatora. Zero bibliotek, do 2 kB gzip. */
const d = document;
const root = d.documentElement;
const reduced = () => root.classList.contains('reduced-motion');
const sel = '[data-reveal], [data-reveal-group]';

function prepare(el) {
  if (el.dataset.revealDelay) el.style.setProperty('--reveal-delay', `${parseInt(el.dataset.revealDelay, 10) || 0}ms`);
  const items = el.hasAttribute('data-reveal-group') && !el.querySelector('[data-reveal-item]')
    ? [...el.children]
    : [...el.querySelectorAll('[data-reveal-item]')];
  items.forEach((it, i) => it.style.setProperty('--reveal-i', Math.min(i, 8)));
}

let io = null;
function show(el) { el.classList.add('is-in'); }
function observe(scope) {
  const list = scope.matches && scope.matches(sel) ? [scope, ...scope.querySelectorAll(sel)] : [...scope.querySelectorAll(sel)];
  list.forEach((el) => {
    if (el.classList.contains('is-in') || el.dataset.motionReady) return;
    el.dataset.motionReady = '1';
    if (reduced() || !('IntersectionObserver' in window)) { show(el); return; }
    prepare(el);
    const r = el.getBoundingClientRect();
    if (r.top < innerHeight * 0.92 && r.bottom > 0) { show(el); return; }
    io ??= new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    io.observe(el);
  });
}
observe(d);
d.addEventListener('shopify:section:load', (e) => observe(e.target));
new MutationObserver((muts) => {
  muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) observe(n); }));
}).observe(d.body, { childList: true, subtree: true });

/* Pasek ogłoszeń: komunikaty, które zawinęły się do ukrytego wiersza, dostają inert (D11: klawiatura wchodziła w niewidoczne linki). */
const barList = d.querySelector('.announcement-bar__list');
if (barList) {
  const syncBar = () => [...barList.children].forEach((li) => { li.inert = li.offsetTop >= barList.clientHeight; });
  syncBar();
  addEventListener('resize', syncBar, { passive: true });
  d.fonts?.ready.then(syncBar);
}

/* Nagłówek: kurczenie i chowanie przy przewijaniu w dół (tylko klasy na <html>, ruch w CSS nagłówka). */
let lastY = scrollY;
let ticking = false;
function onScroll() {
  const y = scrollY;
  root.classList.toggle('is-scrolled', y > 8);
  if (!reduced()) {
    if (y > 160 && y - lastY > 4) root.classList.add('is-scrolling-down');
    else if (lastY - y > 4 || y <= 160) root.classList.remove('is-scrolling-down');
  }
  lastY = y;
  ticking = false;
}
addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
onScroll();

export { observe };
